import type {Content} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import dynamic from 'next/dynamic'
import type {FC} from 'react'
import type {Context} from 'src/common/types'
import {CarouselDefault} from './DefaultVariation'
import {DoubleImageCarousel} from './DoubleImageCarousel'
import {EventHero} from './EventHero'
import {FeaturedPosts} from './FeaturedPosts'
import {TimelineCarousel} from './TimelineCarousel'

const ImagesVariation = dynamic(() => import('./ImagesVariation').then((mod) => mod.ImagesVariation), {
  ssr: false,
})

/**
 * Props for `Carousel`.
 */
export type CarouselProps = SliceComponentProps<Content.CarouselSlice> & {context: Context}

/**
 * Component for "Carousel" Slices.
 */
const Carousel: FC<CarouselProps> = ({slice, index: componentIndex, context: {pageUid, blogPosts}}) => {
  switch (slice.variation) {
    case 'imagesCarousel':
      return <ImagesVariation slice={slice} />
    case 'default':
      return <CarouselDefault slice={slice} componentIndex={componentIndex} pageUid={pageUid} />
    case 'doubleImageCarousel':
      return <DoubleImageCarousel slice={slice} componentIndex={componentIndex} pageUid={pageUid} />
    case 'featurePosts':
      return <FeaturedPosts slice={slice} componentIndex={componentIndex} pageUid={pageUid} blogPosts={blogPosts} />
    case 'eventHero':
      return <EventHero slice={slice} componentIndex={componentIndex} />
    case 'timeline':
      return (
        <TimelineCarousel
          buttonLabel={isFilled.keyText(slice.primary.feature_button_label) ? slice.primary.feature_button_label : ''}
          buttonLink={slice.primary.feature_button_link}
          pageUid={pageUid ?? ''}
          sliceType={slice.slice_type}
          variation={slice.variation}
          paddingTop={slice.primary.padding_top}
          paddingBottom={slice.primary.padding_bottom}
          cards={slice.primary.cards.map((card) => ({
            title: isFilled.keyText(card.title) ? card.title : '',
            description: isFilled.keyText(card.description) ? card.description : '',
            image: card.image,
          }))}
        />
      )
    default:
      return null
  }
}

export default Carousel
